import React from 'react';
import { Route } from 'react-router-dom';

import {
  CALCULATION_CONSTANTS_CHARGES_PATH,
  CALCULATION_CONSTANTS_DISTRIBUTION_TARIFFS_PATH,
  CALCULATION_CONSTANTS_INDICATIVE_PRICES_PATH,
  CALCULATION_CONSTANTS_IPCA_PATH,
  CALCULATION_CONSTANTS_PLD_PATH,
  CALCULATION_CONSTANTS_TARIFF_FLAGS_PATH,
} from '@seller-area/routers/constants';

const IndicativePricesPage = React.lazy(() => import('@seller-area/pages/indicative-prices'));
const InflationIpcaPage = React.lazy(() => import('@seller-area/pages/inflation-ipca'));
const TariffFlagsPage = React.lazy(() => import('@seller-area/pages/tariff-flags'));
const DistributionTariffsPage = React.lazy(() => import('@seller-area/pages/distribution-tariffs'));
const RegulatoryChargesPage = React.lazy(() => import('@seller-area/pages/regulatory-charges'));
const PldPage = React.lazy(() => import('@seller-area/pages/pld'));

export const pricingRoutes = (): JSX.Element[] => [
  <Route
    key={CALCULATION_CONSTANTS_INDICATIVE_PRICES_PATH}
    path={CALCULATION_CONSTANTS_INDICATIVE_PRICES_PATH}
    element={<IndicativePricesPage />}
  />,
  <Route
    key={CALCULATION_CONSTANTS_IPCA_PATH}
    path={CALCULATION_CONSTANTS_IPCA_PATH}
    element={<InflationIpcaPage />}
  />,
  <Route
    key={CALCULATION_CONSTANTS_TARIFF_FLAGS_PATH}
    path={CALCULATION_CONSTANTS_TARIFF_FLAGS_PATH}
    element={<TariffFlagsPage />}
  />,
  <Route
    key={CALCULATION_CONSTANTS_DISTRIBUTION_TARIFFS_PATH}
    path={CALCULATION_CONSTANTS_DISTRIBUTION_TARIFFS_PATH}
    element={<DistributionTariffsPage />}
  />,
  <Route
    key={CALCULATION_CONSTANTS_CHARGES_PATH}
    path={CALCULATION_CONSTANTS_CHARGES_PATH}
    element={<RegulatoryChargesPage />}
  />,
  <Route key={CALCULATION_CONSTANTS_PLD_PATH} path={CALCULATION_CONSTANTS_PLD_PATH} element={<PldPage />} />,
];
